import { render, staticRenderFns } from "./MSecondaryGraphicIndex.vue?vue&type=template&id=57b7b3f0&"
import script from "./MSecondaryGraphicIndex.vue?vue&type=script&lang=ts&"
export * from "./MSecondaryGraphicIndex.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports